import { formatPrice } from "@/lib/constants";
import { useLang, t, prodName } from "@/lib/i18n";

export default function CocktailCard({ cocktail }) {
  const lang = useLang();
  const price = formatPrice(cocktail);
  return (
    <article
      data-testid={`cocktail-card-${cocktail.id}`}
      className="bg-[var(--card)] rounded-xl overflow-hidden border border-[#C5A059]/45 shadow-lg"
    >
      <div className="relative aspect-[4/5] overflow-hidden">
        <img
          src={cocktail.image}
          alt={cocktail.name}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
      <div className="px-4 pt-4 flex items-start justify-between gap-3">
        <h3 className="font-display font-semibold text-2xl text-[var(--bordeaux)] leading-tight">
          {prodName(cocktail, lang)}
        </h3>
        {price && (
          <span data-testid={`price-${cocktail.id}`} className="font-display font-bold text-2xl text-[var(--bordeaux)] whitespace-nowrap">
            {price}
          </span>
        )}
      </div>
      <div className="mt-2 mx-4 h-px bg-[#C5A059]/40" aria-hidden="true" />
      <div className="px-4 py-4 space-y-3">
        {cocktail.ingredients && cocktail.ingredients.length > 0 && (
          <ul className="space-y-1">
            {cocktail.ingredients.map((ing) => (
              <li key={ing} className="flex items-start gap-2 text-sm text-[var(--text-2)]">
                <span className="mt-[7px] h-1 w-1 rotate-45 bg-[#C5A059] shrink-0" aria-hidden="true" />
                {ing}
              </li>
            ))}
          </ul>
        )}
        {cocktail.preparation && (
          <p className="text-xs text-[var(--muted)] leading-relaxed">
            <span className="font-cinzel text-[10px] tracking-widest uppercase text-[#C5A059] block mb-0.5">{t(lang, "preparation")}</span>
            {cocktail.preparation}
          </p>
        )}
        {cocktail.garnish && (
          <p className="text-xs text-[var(--muted)] leading-relaxed">
            <span className="font-cinzel text-[10px] tracking-widest uppercase text-[#C5A059] block mb-0.5">{t(lang, "garnish")}</span>
            {cocktail.garnish}
          </p>
        )}
        {cocktail.notes && (
          <p className="text-xs italic text-[var(--muted)] leading-relaxed border-t border-[#C5A059]/15 pt-2">
            {cocktail.notes}
          </p>
        )}
      </div>
    </article>
  );
}
